import { render, staticRenderFns } from "./s3-multi-uploader.vue?vue&type=template&id=352b9000"
import script from "./s3-multi-uploader.vue?vue&type=script&lang=ts"
export * from "./s3-multi-uploader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports